module.exports = __webpack_public_path__ + "img/success.735d935f.png";